<form class="recovery" *ngIf="form" [formGroup]="form">
  <h6 class="title" i18n="@@ForgotPassword">{{ title | translate }}</h6>
  <p class="desc" i18n="@@RecoveryCpfDescription">
    {{ 'RecoveryCpfDescription' | translate }}
  </p>

  <app-shared-form-input-text
    formControlName="cpf"
    label="{{ 'RecoveryCpfCpf' | translate }}"
    placeholder="{{ 'RecoveryCpfCpf' | translate }}"
    name="cpf"
    mask="000.000.000-00"
  ></app-shared-form-input-text>

  <app-shared-form-input-text
    formControlName="email"
    label="{{ 'RecoveryEmailEmailaddress' | translate }}"
    placeholder="{{ 'RecoveryEmailEmailaddress' | translate }}"
    name="email"
    type="email"
  ></app-shared-form-input-text>

  <div class="field-group">
    <label>{{ 'RecoveryCpfPhone' | translate }}</label>
    <div class="phone-field">
      <ngx-mat-intl-tel-input
        [preferredCountries]="preferredCountries"
        [enablePlaceholder]="true"
        [enableSearch]="true"
        name="phone"
        formControlName="phone"
        [attr.aria-label]="'RecoveryCpfPhone' | translate"
      ></ngx-mat-intl-tel-input>
    </div>
    <div class="field-error" *ngIf="form.controls['phone'].invalid && form.controls['phone'].touched">
      {{ 'InvalidPhoneNumber' | translate }}
    </div>
  </div>

  <app-turnstile-widget
    *ngIf="!captchaBypassed"
    (tokenReceived)="captchaToken = $event"
    (tokenExpired)="captchaToken = null"
  ></app-turnstile-widget>

  <button
    class="submit-btn"
    [disabled]="
      isLoading ||
      form.invalid ||
      !captchaToken ||
      (!sendCodePermission && lastSendTime !== null)
    "
    (click)="submit()"
  >
    <ng-container *ngIf="!sendCodePermission && lastSendTime !== null; else openToSend">
      Wait {{ getDiffLastTimeAndNowInSec() }}...
    </ng-container>
    <ng-template #openToSend>
      <ng-container *ngIf="!isLoading">{{ 'Send Code' | translate }}</ng-container>
      <ng-container *ngIf="isLoading">
        <mat-spinner diameter="20"></mat-spinner> {{ 'Loading...' | translate }}
      </ng-container>
    </ng-template>
  </button>
</form>
